import { SMTiltPRBuildingHeight, buildingHeightMetric } from 'projectDesign/components/projectConfiguration/fields/buildingHeight';
import clientName from 'projectDesign/components/projectConfiguration/fields/clientName';
import clientAddress from 'projectDesign/components/projectConfiguration/fields/clientAddress';
import elevation, { elevationMetric } from 'projectDesign/components/projectConfiguration/fields/elevation';
import { smTiltPRRoofType } from 'projectDesign/components/projectConfiguration/fields/roofType';
import seismicSs from 'projectDesign/components/projectConfiguration/fields/seismicSs';
import snowLoad, { snowLoadMetric } from 'projectDesign/components/projectConfiguration/fields/snowLoad';
import smTiltPrSpans, { preferredSpanMetric } from 'projectDesign/components/projectConfiguration/fields/span';
import {WindExposure} from 'projectDesign/components/projectConfiguration/fields/windExposure';
import { asce716WindSpeedForSfmAndSm, asce716WindSpeedMetric } from 'projectDesign/components/projectConfiguration/fields/windSpeed';
import { checkEnvironmentalFactors } from 'projectDesign/components/projectConfiguration/utils/checkEnvironmentalFactors';
import { checkLongestBuildingLength, checkSeismic, checkShortestBuildingLength, checkBuildingHeight, checkSeismicSds, checkTornadoSpeed, checkFieldNotEmpty } from '__editor/components/roofsSelector/components/roofsSelectorSaveLoadProject/utils/validateProject';
import { state } from '__common/store';
import { getASCE716722LocationsResidentalAdditionalInputs } from '../fields/getASCE716LocationsResidentalAdditionalInputs';
import { ascenderMidAndEndClamps, smMidAndEndClamps } from 'projectDesign/components/projectConfiguration/fields/smClamps';
import { asce716and722BuildingCode } from '../fields/buildingCode';
import getSoilClassField from 'projectDesign/components/projectConfiguration/fields/soilClass';
import parapetHeight, { rmIFIParapetHeightField, rmIFIParapetHeightMetricField } from '../fields/rmIFIParapetHeight';
import longestBuildingLength, { longestBuildingLengthMetric } from '../fields/longestBuildingLength';
import shortestBuildingLength, { shortestBuildingLengthMetric } from '../fields/shortestBuildingLength';
import { isMetricUnit } from 'engineering/components/engineeringProjectDocuments/utils/unitTypes';
import { ascenderRailFinish } from 'projectDesign/components/projectConfiguration/fields/railFinish';
import smTiltPrRailFinish from 'projectDesign/components/projectConfiguration/fields/smTiltPrRailFinish.json'
import { isASCE722 } from '__common/constants/buildingCodes';
import seismicSds from '../fields/seismicSds';
import { riskCategoryCheckForTornadoSpeed } from '../constraints/constraints';
import tornadoSpeed from '../fields/tornadoSpeed';
import riskCategory from '../fields/riskCategory';

import { isSMTiltPRWithAscender } from '__common/constants/products';
import domesticContent from '../fields/isDomesticContent';


function getWindSpeedField(buildingCodeValue: number, inputUnit?: number) {
  if(isMetricUnit(inputUnit)) {
    return asce716WindSpeedMetric(false);
  } else {
  return asce716WindSpeedForSfmAndSm;
  }
}
export default (buildingCodeValue: number) => {
  const {
    projectConfiguration: {
      projectEnvConfig: {
        seismic_ss, building_height, building_length, shortest_building_length, seismic_sds, risk_category, tornado_speed,
        wind_speed, is_os_project, snow_load, elevation:elevation_value, domestic_content
      }, productId, inputUnit, railsProductId
    },
  } = state();

  const tornadoSpeedField = isASCE722(buildingCodeValue) && riskCategoryCheckForTornadoSpeed(risk_category) ? tornadoSpeed : [];
  const buildingCodeField = asce716and722BuildingCode(false, false, productId);
  const windSpeed = getWindSpeedField(buildingCodeValue, inputUnit);
  const buildingHeight = isMetricUnit(inputUnit) ? buildingHeightMetric : SMTiltPRBuildingHeight;;
  const snowLoadField = isMetricUnit(inputUnit) ? snowLoadMetric: snowLoad
  const elevationField = isMetricUnit(inputUnit) ? elevationMetric : elevation;
  const preferredSpanField = isMetricUnit(inputUnit) ? preferredSpanMetric : smTiltPrSpans;
  const shortestBuilding = isMetricUnit(inputUnit) ? shortestBuildingLengthMetric: shortestBuildingLength;
  const longestBuilding = isMetricUnit(inputUnit) ? longestBuildingLengthMetric: longestBuildingLength;
  const parapetHeight = isMetricUnit(inputUnit) ? rmIFIParapetHeightMetricField: rmIFIParapetHeightField;
  const railFinish = isSMTiltPRWithAscender(railsProductId) ? ascenderRailFinish: JSON.parse(JSON.stringify(smTiltPrRailFinish)) ; 

  checkEnvironmentalFactors(buildingCodeField, windSpeed, snowLoad, seismicSs, elevation);
  const soilClass = getSoilClassField(buildingCodeValue, productId);
  soilClass['label']='site_class';
  seismicSs.missing = !checkSeismic(seismic_ss);
  seismicSds.missing = !checkSeismicSds(seismic_sds);
  buildingHeight.missing = !checkBuildingHeight(building_height * 1);
  longestBuilding.missing = !checkLongestBuildingLength(building_length * 1);
  shortestBuilding.missing = !checkShortestBuildingLength(shortest_building_length * 1);
  tornadoSpeed.missing = !checkTornadoSpeed(tornado_speed);
  windSpeed.missing = !checkFieldNotEmpty(wind_speed);
  elevationField.missing = !checkFieldNotEmpty(elevation_value);
  snowLoadField.missing = !checkFieldNotEmpty(snow_load);
  riskCategory.missing = !checkFieldNotEmpty(risk_category);
  domesticContent.missing = !checkFieldNotEmpty(domestic_content);
  const seismicSdsField = isASCE722(buildingCodeValue) ? seismicSds : [];
  const cfg = {
    zipCode: 'zipcode',
    Area: 'Peoria, AZ',
    Client: {
      label: '',
      fields: [
        clientName,
        clientAddress,
      ],
    },
    LocationAndLoads: {
      label: 'loads',
      fields: [
        buildingCodeField,
        WindExposure(is_os_project),
        windSpeed,
        snowLoadField,
        elevationField,
        seismicSs,
        seismicSdsField,
        soilClass,
        ...getASCE716722LocationsResidentalAdditionalInputs(buildingCodeValue),
        tornadoSpeedField,
      ],
    },
    BuildingDescription: {
      label: 'Building description',
      fields: [
        buildingHeight,
        ...(isSMTiltPRWithAscender(railsProductId) ? [
          ascenderMidAndEndClamps('mid_clamps_choices'),
          ascenderMidAndEndClamps('end_clamps_choices'),
        ] : [
          smMidAndEndClamps('mid_clamps_choices', 'mid_clamps'),
          smMidAndEndClamps('end_clamps_choices', 'end_clamps'),
        ]),
        smTiltPRRoofType,
        parapetHeight,
        shortestBuilding,
        longestBuilding,
      ],
    },
    Spans: {
    label: '',
    fields: [
      preferredSpanField,
      domesticContent,
    ],
  },
    railFinish,
    railTypes: true,
  };
  return cfg;
};
